import React from 'react';
import ReactPlayer from 'react-player';
import Meta from 'components/templates/Seo/Meta';
import BlankContainer from 'components/atoms/structure/BlankContainer';
import styled from 'styled-components';

const Container = styled.div`
    max-width: 1200px;
    margin: 0 auto;
    padding: 2rem;
`;

const PlayerWrapper = styled.div`
    position: relative;
    padding-top: 56.25%; /* 16:9 Aspect Ratio */
    margin: 2rem 0;

    .react-player {
        position: absolute;
        top: 0;
        left: 0;
        width: 100% !important;
        height: 100% !important;

        iframe {
            border-radius: 8px;
        }
    }
`;

const Title = styled.h1`
    font-size: 2rem;
    font-weight: bold;
    margin-bottom: 1rem;
    color: #333;
`;

const Description = styled.p`
    font-size: 1rem;
    color: #666;
    margin-bottom: 2rem;
`;

const Tutorial = () => {
    // URL do vídeo do Vimeo - substitua pela URL desejada
    const vimeoUrl = 'https://vimeo.com/1143555918'; // Exemplo: substitua pelo ID real do vídeo

    return (
        <>
            <Meta title="Tutorial" description="Tutorial do PFA" />
            <BlankContainer>
                <Container>
                    <Title>Tutorial</Title>
                    <Description>Assista ao vídeo tutorial para aprender mais sobre a plataforma.</Description>
                    <PlayerWrapper>
                        <ReactPlayer
                            url={vimeoUrl}
                            width="100%"
                            height="100%"
                            controls={true}
                            className="react-player"
                            config={{
                                vimeo: {
                                    playerOptions: {
                                        responsive: true,
                                        autoplay: false
                                    }
                                }
                            }}
                        />
                    </PlayerWrapper>
                </Container>
            </BlankContainer>
        </>
    );
};

export default Tutorial;
